import { AxiosError, AxiosResponse } from 'axios';

import { API_HANDLERS, ShareInfo, ShareResponseError } from 'api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

interface usePspViewShareDataQueryOptions {
    pucKey: string;
    queryOptions?: UseQueryOptions<AxiosResponse<ShareInfo>, AxiosError<ShareResponseError>>;
}

export function usePspViewShareDataQuery({
    pucKey,
    queryOptions,
}: usePspViewShareDataQueryOptions) {
    const queryFn = () =>
        API_HANDLERS.PSP.VIEW.SHARE_DATA({
            pucKey,
        });

    return useQuery<AxiosResponse<ShareInfo>, AxiosError<ShareResponseError>>({
        queryKey: ['pspViewShareData', pucKey],
        queryFn,
        retry: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        ...queryOptions,
    });
}
